<template>
    <div>
        <b-tabs
            class="learning-path-index-tab apprentice-tab"
            content-class="learning-path-index-content">
            <b-tab
                :title="$t('learning_path.work_fields')"
                active>
                <design-2021-learning-path-category-index-tab-component :lp-categories-in="lpCategoriesIn">
                </design-2021-learning-path-category-index-tab-component>
            </b-tab>
            <b-tab :title="$t('learning_path.classes')">
                <design-2021-learning-path-deadline-series-index-tab-component
                    :las-groups-in="lasGroupsIn"
                    :las-main-groups-in="lasMainGroupsIn"
                    :lp-deadline-series-in="lpDeadlineSeriesIn">
                </design-2021-learning-path-deadline-series-index-tab-component>
            </b-tab>
            <b-tab :title="$t('learning_path.settings')">
                <design2021-learning-path-settings-component :lp-settings="lpSettings">
                </design2021-learning-path-settings-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-index-component',
    props: ['lpCategoriesIn', 'lpDeadlineSeriesIn', 'lasGroupsIn', 'lasMainGroupsIn', 'lpSettings'],
    data() {
        return {
            lpCategories: this.lpCategoriesIn,
        };
    },
};
</script>

<style scoped></style>
